import React, { Component, Fragment } from 'react';

import ThemesSlide from './ThemesSlide';
import SliderArrow from './SliderArrow';

export default class ModalSlider extends Component {
  render() {
    const { themes, themeType, editable, isLastPage, modalType, slideIndex } = this.props;
    return (
      <Fragment>
        {modalType === 'dayModal'
          ? this.renderSliderArrow('left')
          : slideIndex !== 0
          ? this.renderSliderArrow('left')
          : null}
        <ThemesSlide {...themes[slideIndex]} themeType={themeType} editable={editable} />
        {isLastPage
          ? slideIndex !== themes.length - 1
            ? this.renderSliderArrow('right')
            : null
          : this.renderSliderArrow('right')}
      </Fragment>
    );
  }

  renderSliderArrow = arrowType => {
    const { changeSlide, slideIndex, themes } = this.props;
    return (
      <SliderArrow
        type={arrowType}
        onClick={changeSlide}
        slideIndex={slideIndex}
        length={themes.length}
      />
    );
  };

  handleArrowKeys = e => {
    const { themes, slideIndex, changeSlide } = this.props;
    if (e.keyCode === 37) {
      // left
      changeSlide((slideIndex + themes.length - 1) % themes.length, slideIndex);
    } else if (e.keyCode === 39) {
      // right
      changeSlide((slideIndex + themes.length + 1) % themes.length, slideIndex);
    }
  };

  componentDidMount() {
    window.addEventListener('keydown', this.handleArrowKeys);
  }

  componentWillUnmount() {
    window.removeEventListener('keydown', this.handleArrowKeys);
  }
}



// WEBPACK FOOTER //
// ./src/screens/Places/ModalSlider.jsx